import { LogoSpace } from '@app/components/LayoutLogin/ui/components/LogoSpace';

import type { FC } from 'react';

export const ContactInformation: FC = () => (
  <div className="ContactInformation">
    <h4>Контакты</h4>
    <div className="ContactInformation__details">
      <div>E-mail: mail@byhelp.ru</div>
      <div>Телефон: +7 (383) 210-00-10</div>
    </div>
    <LogoSpace />
  </div>
);
